module.exports = __webpack_public_path__ + "img/CtrlRoom_BT_on.9ac836de.png";